import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useInvoiceFeature } from '../../hooks/useInvoiceFeature';
import { useMyInvoiceTerms } from '../../hooks/useMyInvoiceTerms';
import { resolveInvoicePayer, remainingCredit } from '../../utils/invoicePayer';
import { formatKr as kr } from '../../utils/formatKr';
import { COLORS, FONTS } from '../../styles/tokens';

// Bestillerens fakturavilkår (profil). Vises bare for godkjente fakturakunder.
export default function InvoiceTermsCard() {
  const { currentUser, userDoc } = useAuth();
  const { enabled } = useInvoiceFeature();
  const { personal, org } = useMyInvoiceTerms({ uid: currentUser?.uid, orgId: userDoc?.orgId });
  const payer = enabled ? resolveInvoicePayer({ userDoc, personal, org }) : null;
  if (!payer) return null;

  const c = payer.customer;
  const rows = [
    ['Betalingsfrist', c.termsDays != null ? `${c.termsDays} dager` : '–'],
    ['Kredittgrense', kr(c.creditLimit)],
    ['Utestående', kr(c.exposure)],
    ['Gjenstående kreditt', kr(remainingCredit(c))],
  ];

  return (
    <section style={styles.card} aria-label="Fakturavilkår">
      <h2 style={styles.title}>Fakturavilkår</h2>
      <p style={styles.scope}>{payer.payerType === 'org' ? 'Gjelder organisasjonen' : 'Gjelder deg selv'}</p>
      {rows.map(([label, value]) => (
        <div key={label} style={styles.row}>
          <span style={styles.label}>{label}</span>
          <span style={styles.value}>{value}</span>
        </div>
      ))}
      <p style={styles.note}>Spørsmål om kreditt? Kontakt Tippi.</p>
    </section>
  );
}

const styles = {
  card:  { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 20, padding: 18, marginBottom: 16 },
  title: { fontFamily: FONTS.display, fontSize: 24, fontWeight: 700, margin: 0, color: COLORS.textDark },
  scope: { fontSize: 12.5, color: COLORS.textMid, margin: '2px 0 8px' },
  row:   { display: 'flex', justifyContent: 'space-between', gap: 12, padding: '10px 0', borderBottom: `1px solid ${COLORS.border}`, fontSize: 14 },
  label: { color: COLORS.textMid },
  value: { fontWeight: 700, color: COLORS.textDark },
  note:  { fontSize: 12.5, color: COLORS.textLight, margin: '12px 0 0' },
};
